import { useMutation } from '@apollo/client';
import { toast } from 'react-toastify';
import { graphql } from '~/apollo/generated/v3';
import { Confirm } from '~/components/common/Confirm';
import { Tooltip } from '~/components/common/Tooltip';
import type { RefetchQueries } from '~/utils/graphql';

const DELETE_REVIEW_COMMENT = graphql(`
  mutation DeleteReviewComment($id: Int!) {
    deleteReviewComment(id: $id)
  }
`);

type Props = {
  children: (confirmDelete: () => void, loading: boolean) => JSX.Element;
  commentId: number;
  refetchQueries: RefetchQueries;
};

export function DeleteReviewComment({
  children,
  commentId,
  refetchQueries,
}: Props) {
  const [deleteReviewComment, { loading }] = useMutation(
    DELETE_REVIEW_COMMENT,
    {
      variables: { id: commentId },
      refetchQueries,
    },
  );

  const handleDelete = async () => {
    try {
      await deleteReviewComment();
      toast.success('Review comment deleted.');
    } catch (err) {
      console.log('Error deleting review comment', err);
      toast.error(
        'There was a problem deleting the review comment. Please try again.',
      );
    }
  };

  return (
    <Confirm onConfirm={handleDelete}>
      {confirm => (
        <Tooltip message="Delete comment">{children(confirm, loading)}</Tooltip>
      )}
    </Confirm>
  );
}
